<p-toast />
<div class="p-4 card" style="height: 100dvh;">
    <div class="p-6 mx-auto" style="height: 100%; max-width: 1500px;">
        <h3>Documents public</h3>
        <app-document [typeLienDocument]="typeLienDocument" [idLien]="idLien" [numero]="numero" [showFolders]="false"
            [canAddDocument]="false" [readonly]="true" [public]="true"></app-document>
    </div>
</div>